<script>
import AppConfigService from '../services/AppConfigService'
export default {
  name: 'SmartsuppLiveChat',
  functional: true,
  render: (createElement) => {
    let smartsupp = AppConfigService.getConfigValueSync('smartsupp')
    if (!smartsupp || !smartsupp.key) {
      return ''
    }
    return createElement('script', `
    var _smartsupp = _smartsupp || {}
    _smartsupp.key = '${smartsupp.key}'
    window.smartsupp || (function (d) {
      var s, c, o = smartsupp = function () {
        o._.push(arguments)
      }
      o._ = []
      s = d.getElementsByTagName('script')[0]
      c = d.createElement('script')
      c.type = 'text/javascript'
      c.charset = 'utf-8'
      c.async = true
      c.src = 'https://www.smartsuppchat.com/loader.js?'
      s.parentNode.insertBefore(c, s)
    })(document)`)
  }
}
</script>
